import {Component, Prop, Vue, Watch} from '@/node_modules/nuxt-property-decorator';
import RoutingUtil from "@/classes/view/routing-util";
import APage from '@/classes/page/a-page';
import {appModule} from '@/store/app';
import {priceMachineModule} from '@/store/price-machine';
import {FaqPlan} from "@/configs/faq-plan";
import {Price} from "@/configs/price";
import {OfficialServices} from "@/configs/official/official-services";

import MPriceMachine from '@/components/module/MPriceMachine.vue';
import MPrice from '@/components/module/MPrice.vue';
import MToggleList from '@/components/module/MToggleList.vue';
import {TweenLite} from 'gsap'

@Component({
	layout: 'teaser',
    components: {
        MToggleList,
        MPrice,
        MPriceMachine,
    }
})
export default class Index extends APage {

	public title: string;

    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-page';
	public mydivider: string = 'full';


    ///////// このページ ////////////////////////////////////////////
    public faqdata: any = FaqPlan;


    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'プラン｜THOUGHT ブランディングツール'
        }
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
		return RoutingUtil.transition(to, from);
	}

    public created(){

		///////// 全ページ共通 ////////////////////////////////////////////
		this.setPagetype( appModule, this.mypagetype, this.mydivider );

        ///////// このページ ////////////////////////////////////////////
    }

    ///////// Computed ////////////////////////////////////////////


	public get deviceSize(): any {
    	return appModule.deviceSize;
	}


}




